import { toTitleCase } from "../../../../Utils/stringUtls";
import {
  otherServices,
  programMngt,
} from "../../OptionalFeatures/ProgramManagementService";
const ProgramManagementServicesOverview = ({ data }) => {
  const {
    of_pms_processor,
    of_pms_company_name,
    of_pms_contact_name,
    of_pms_job_title,
    of_pms_phone_number,
    of_pms_country,
    of_pms_email,
    of_pms_other_services,
    of_pms_other_services_other,
    of_pms_other_vendors,
  } = data["6_2"];
  return (
    <div className="forms-instance" style={{ color: "#111" }}>
      <div i2c-grid="grid gap-sm" className="">
        <div i2c-grid="12@md" className="review-summary-sub-heading">
          <div className="fw-700 font-bold">Program Management Services</div>
          <div>
            This service includes consulting and management of card programs,
            including operational support and management of key program
            components to ensure that they are optimized for growth and
            profitability.
          </div>
          <div className="mt-8 overview-val-text">
            {programMngt[of_pms_processor]?.label ?? "-"}
          </div>
        </div>
        {of_pms_processor === 2 && (
          <>
            <div i2c-grid="6@md">
              <div className="overview-help-text font-bold">Company Name</div>
              <div className="overview-val-text">
                {of_pms_company_name?.length
                  ? toTitleCase(of_pms_company_name)
                  : "-"}
              </div>
            </div>
            <div i2c-grid="6@md">
              <div className="overview-help-text font-bold">Contact Name</div>
              <div className="overview-val-text">
                {of_pms_contact_name?.length
                  ? toTitleCase(of_pms_contact_name)
                  : "-"}
              </div>
            </div>

            <div i2c-grid="6@md">
              <div className="overview-help-text font-bold">Job Title</div>
              <div className="overview-val-text">
                {of_pms_job_title?.length ? toTitleCase(of_pms_job_title) : "-"}
              </div>
            </div>
            <div i2c-grid="6@md">
              <div className="overview-help-text font-bold">Company Phone</div>
              <div className="overview-val-text">
                {of_pms_phone_number?.length
                  ? toTitleCase(of_pms_phone_number)
                  : "-"}
              </div>
            </div>
            <div i2c-grid="6@md">
              <div className="overview-help-text font-bold">Email</div>
              <div className="overview-val-text">
                {of_pms_email?.length ? toTitleCase(of_pms_email) : "-"}
              </div>
            </div>
          </>
        )}
        <div i2c-grid="12@md">
          <div className="font-bold overview-help-text">Other Services</div>
          <div
            className="overview-val-text"
            style={{
              display: "flex",
              gap: "var(--i2c-spacing-3)",
              flexWrap: "wrap",
            }}
          >
            {of_pms_other_services?.length
              ? otherServices.map((network, index) =>
                  of_pms_other_services?.includes(network.value) ? (
                    <span
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "var(--i2c-spacing-2)",
                      }}
                      key={index}
                    >
                      <span>
                        {network.value === 6
                          ? toTitleCase(of_pms_other_services_other)
                          : network.label}
                        ,
                      </span>
                      {/* {of_pms_other_services?.length > index ? ", " : ""} */}
                    </span>
                  ) : (
                    ""
                  ),
                )
              : "-"}
          </div>
        </div>
        <div i2c-grid="12@md">
          <div className="font-bold overview-help-text">
            Other Networks/Vendor Integrations
          </div>
          <div className="overview-val-text">
            {of_pms_other_vendors?.length
              ? toTitleCase(of_pms_other_vendors)
              : "-"}
          </div>
        </div>
      </div>
    </div>
  );
};
export default ProgramManagementServicesOverview;
